module.exports = __webpack_public_path__ + "img/1-10.e1450e68.png";